import { commonTransform, commonTransformWithDetails } from "../handleTransformation";
import { tags } from "../constants";
import { AUTH_EMPLOYEE_MAGIC_LINK,VALIDATE_EMPLOYEES_FROM_CSV_URL, GET_EMPLOYEES_URL, GET_EMPLOYEE_URL, UPDATE_WORK_EMAIL_URL, DEACTIVATE_EMPLOYEES_URL, GET_EMPLOYEES_REPORT_URL,ADD_EMPLOYEES_FROM_CSV_URL } from "services/url.service";

export const employeeMutations = {
  validateEmployeesFromCSV: {
    getUrl: (companyId) => VALIDATE_EMPLOYEES_FROM_CSV_URL(companyId),
    transformResponse: (res) => commonTransformWithDetails(res),
    method: "POST",
  },
  addEmployeesFromCSV: {
    getUrl: (companyId) => ADD_EMPLOYEES_FROM_CSV_URL(companyId),
    transformResponse: (res) => commonTransformWithDetails(res),
    method: "POST",
    invalidatesTags: [tags.EMPLOYEES],
  },
  deactivateEmployee: {
    getUrl: () => DEACTIVATE_EMPLOYEES_URL(),
    transformResponse: (res) => commonTransform(res),
    method: "POST",
    invalidatesTags: [tags.CANDIDATES]
  },
  updateWorkEmail: {
    getUrl: (params) => {
      return UPDATE_WORK_EMAIL_URL(params?.employeeId)
    },
    transformResponse: (res) => commonTransform(res),
    method: "PUT",
    invalidatesTags: [tags.EMPLOYEES],
  },
  authEmployeeMagicLink: {
    getUrl: () => AUTH_EMPLOYEE_MAGIC_LINK(),
    transformResponse: (res) => commonTransform(res),
    method: "POST",
  },
};

export const employeeQueries = {
  getEmployees: {
    getUrl: (params) => {
      return GET_EMPLOYEES_URL(params?.companyId, params?.search, params?.offset, JSON.stringify(params?.filter), params?.includeAdditional)
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.POSITION, tags.CANDIDATES, tags.EMPLOYEES]
  },
  getEmployeeByID: {
    getUrl: (params) => {
      return GET_EMPLOYEE_URL(params?.employeeID)
    },
    transformResponse: (res) => {
      const employees = commonTransform(res)
      return employees.rows[0]
    },
    method: "GET",
    providesTags: [tags.POSITION , tags.EMPLOYEES, tags.CANDIDATES]
  },
  getEmployeesReport: {
    getUrl: (params) => {
      return GET_EMPLOYEES_REPORT_URL(params?.companyId, params?.selectedValues)
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  }
};